// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton__MYBfi","amount":"styles_amount__CO3Ll","depositAmountValue":"styles_depositAmountValue__8it0Z"};